import React from 'react';

const Footer = () => {
  return (
    <footer className="py-[35px] pb-5 bg-[#1a1a2e] text-center text-[#F5F5F0] opacity-0 animate-fadeIn-delayed-8">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <p className="text-[0.85rem] mb-3 text-[#F5F5F0] opacity-80">
          Hosted by
        </p>
        <div className="mb-[18px] inline-block bg-white py-[15px] px-[30px] rounded-lg">
          <img 
            src={require('../assets/Full Logo.png')} 
            alt="Enculture Logo" 
            className="max-w-[160px] h-auto"
          />
        </div>
        <div className="mb-[18px] flex justify-center items-center gap-[15px]">
          <a 
            href="https://enculture.ai" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Website"
            className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(107,77,196,0.1)] border-2 border-[#6B4DC4] text-[#6B4DC4] transition-all duration-300 hover:bg-gradient-to-br hover:from-[#6B4DC4] hover:to-[#4ECDC4] hover:text-white hover:border-transparent hover:-translate-y-[3px]"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </a>
          <a 
            href="https://in.linkedin.com/company/encultureai" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="flex items-center justify-center w-10 h-10 rounded-full bg-[rgba(107,77,196,0.1)] border-2 border-[#6B4DC4] text-[#6B4DC4] transition-all duration-300 hover:bg-gradient-to-br hover:from-[#6B4DC4] hover:to-[#4ECDC4] hover:text-white hover:border-transparent hover:-translate-y-[3px]"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" fill="currentColor"/>
              <circle cx="4" cy="4" r="2" fill="currentColor"/>
            </svg>
          </a>
        </div>
        <p className="text-[0.85rem] text-[#F5F5F0] opacity-70 mb-0">
          © 2025 Enculture. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;

